var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailIcon = function SvgEmailIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile Placeholder"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_100900)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 234",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#09B965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.2 10.562L12 13.6612L16.8 10.562L12 7.46281L7.2 10.562ZM18 10.562V16.7603C18 17.0891 17.8736 17.4044 17.6485 17.6369C17.4235 17.8694 17.1183 18 16.8 18H7.2C6.88174 18 6.57652 17.8694 6.35147 17.6369C6.12643 17.4044 6 17.0891 6 16.7603V10.562C6 10.1095 6.234 9.71901 6.582 9.50207L11.4572 6.35088C11.7875 6.13733 12.2125 6.13733 12.5428 6.35088L17.418 9.50207C17.766 9.71901 18 10.1095 18 10.562Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_100900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "email-icon.613bab52741d1e66ee2fe2e36abaa538.svg";